import { render, staticRenderFns } from "./CbsFormDesignerFilter.vue?vue&type=template&id=0bd1b375&scoped=true"
import script from "./CbsFormDesignerFilter.vue?vue&type=script&lang=js"
export * from "./CbsFormDesignerFilter.vue?vue&type=script&lang=js"
import style0 from "./CbsFormDesignerFilter.vue?vue&type=style&index=0&id=0bd1b375&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd1b375",
  null
  
)

export default component.exports